import { render, staticRenderFns } from "./CaseStudyTableActive.vue?vue&type=template&id=60343bba&scoped=true"
import script from "./CaseStudyTableActive.vue?vue&type=script&lang=js"
export * from "./CaseStudyTableActive.vue?vue&type=script&lang=js"
import style0 from "./CaseStudyTableActive.vue?vue&type=style&index=0&id=60343bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60343bba",
  null
  
)

export default component.exports